/**
 *
 * @author Matthew Rawson @ 22/08/2018 17:16
 * @description
 * @notes
 */
import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {Col, Row} from "react-bootstrap"
import styled from "styled-components"

import id from "@irati/utils/id"
import padding from "@irati/ui/src/global/padding"
import {PeriodValue, StartAt, NextTriggerAtOverride, QuestionCount} from "@irati-web/fields/schedule"
import {injectIntl} from "@irati/utils/lang/injectIntl"

import isCycleCustom from "../../../helpers/cycle/isCycleCustom"

const SpacedCol = styled(Col)`
  margin-bottom: ${padding.small};
`


class FrequencySection extends PureComponent {
  static propTypes = {
    form: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    cycle: PropTypes.object.isRequired,
    formatMessage: PropTypes.func.isRequired
  }
  static defaultProps = {
    disabled: false
  }

  render() {
    const idNamespace = id("FrequencySection", this.props)
    const {form, onChange, disabled, cycle, formatMessage} = this.props
    const scheduleIsNew = !form.lastTriggeredAt
    const {runOnce} = cycle
    const startAtLabelOverride = runOnce ? formatMessage({id: "insights.fields.schedule.runOnce.startAt.label"}) : undefined

    return (
      <div id={idNamespace}>
        {!isCycleCustom(cycle) && (
          <Row>
            <SpacedCol xs={12}>
              <PeriodValue disabled={disabled} id={idNamespace} schedule={form} onChange={onChange} />
              <QuestionCount disabled={disabled} id={idNamespace} schedule={form} onChange={onChange} />
            </SpacedCol>
          </Row>
        )}
        <Row>
          {scheduleIsNew
            ? <StartAt disabled={disabled} id={idNamespace} schedule={form} onChange={onChange} label={startAtLabelOverride} />
            : <NextTriggerAtOverride
              disabled={disabled}
              id={idNamespace}
              schedule={form}
              onChange={onChange}
              label="insights.fields.surveySettings.nextTriggerAtOverride.label" />}
        </Row>
      </div>
    )
  }
}

export default injectIntl(FrequencySection)
